import {uuid} from "../../@types/schema";

export const START_EDITING = 'START_EDITING';
export const STOP_EDITING = 'STOP_EDITING';
export const POST_MESSAGE = 'POST_MESSAGE';
export const REMOVE_MESSAGES = 'REMOVE_MESSAGES';

export type SaveStatusActionTypes = 'START_EDITING' | 'STOP_EDITING' | 'ADD_MESSAGE' | 'REMOVE_MESSAGES';

export type StartEditingResult = {
    type: typeof START_EDITING,
    payload: {
        page: string,
        id: uuid
    }
}

export type StopEditingResult = {
    type: typeof STOP_EDITING,
    payload: {
        page: string,
        id: uuid
    }
}

export type PostMessageResult = {
    type: typeof POST_MESSAGE,
    payload: {
        page: string,
        id: uuid,
        message: {
            id: uuid,
            field: string,
            method: string,
            value: any
        }
    }
}

export type RemoveMessagesResult = {
    type: typeof REMOVE_MESSAGES,
    payload: {
        page: string,
        id: uuid,
        messageIds: uuid[]
    }
}

export type PostMessageContent = {
    id: uuid;
    field: string;
    method: string;
    value: any;
}

/**
 * Start editing an item.
 *
 * @param {string} page - which page (contacts, tasks, etc)
 * @param {uuid} id - saved status, true (saved) or false (unsaved)
 * @return {StartEditingResult}
 */
export const startEditing = (page: string, id: uuid): StartEditingResult => {
    return {type: START_EDITING, payload: {page, id}};
};

/**
 * Finish editing an item.
 *
 * @param {string} page - which page (contacts, tasks, etc)
 * @param {uuid} id - saved status, true (saved) or false (unsaved)
 * @return {StopEditingResult}
 */
export const stopEditing = (page: string, id: uuid): StopEditingResult => {
    return {type: STOP_EDITING, payload: {page, id}};
};

/**
 * Post a message.
 *
 * @param {string} page - which page (contacts, tasks, etc)
 * @param {uuid} id - saved status, true (saved) or false (unsaved)
 * @param {{id: uuid, field: string, method: string, value: any}} message
 * @return {PostMessageResult}
 */
export const postMessage = (page: string, id: uuid, message: PostMessageContent): PostMessageResult => {
    return {type: POST_MESSAGE, payload: {page, id, message}};
};

/**
 * Remove a message.
 *
 * @param {string} page - which page (contacts, tasks, etc)
 * @param {uuid} id - id of the target object
 * @param {uuid[]} messageIds - id of the message to remove
 * @return {RemoveMessagesResult}
 */
export const removeMessages = (page: string, id: uuid, messageIds: uuid[]): RemoveMessagesResult => {
    return {type: REMOVE_MESSAGES, payload: {page, id, messageIds}};
};

